/**
 * Настройки интерфейса игрока в браузере.
 *
 * Назначение файла: после З-11 кошелёк и Очаг приходят с сервера; в localStorage
 * остаются только prefs, не связанные с правилами игры.
 */

const PREFS_KEY = "hive.ui.prefs.v1";

export type UiPrefs = {
  readonly lastEmail: string | null;
  /** Почта, для которой игрок закрыл баннер подтверждения. Вернуть его можно в настройках. */
  readonly verifyHiddenFor: string | null;
  /** Игрок прошёл первые подсказки: показывать их заново не нужно. */
  readonly onboardingDone: boolean;
  /** Выбранный облик героя. Косметика, сервер о нём пока не знает (З-32). */
  readonly heroAppearance: string | null;
};

const DEFAULT_PREFS: UiPrefs = {
  lastEmail: null,
  verifyHiddenFor: null,
  onboardingDone: false,
  heroAppearance: null,
};

export function loadUiPrefs(): UiPrefs {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return DEFAULT_PREFS;
    const parsed = JSON.parse(raw) as Partial<UiPrefs>;
    return { ...DEFAULT_PREFS, ...parsed };
  } catch {
    return DEFAULT_PREFS;
  }
}

/**
 * Дописать настройки, не затирая остальные.
 * Запись целым объектом уже теряла закрытый баннер при следующем входе.
 */
export function saveUiPrefs(patch: Partial<UiPrefs>): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...loadUiPrefs(), ...patch }));
  } catch {
    // ignore
  }
}
